// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';


export async function getDataRoleModel() {
    return api.fetchData('/role-model/all').then(res => {
        return res.data;
    });
}

export async function getDataRoleModelByIdDepartemen(id_departemen) {
    return api.fetchData('/role-model/detail-by-id-departemen', {
        'id_departemen' : id_departemen
    }).then(res => {
        return res.data;
    });
}